import React, { useState } from 'react';

const Pagination = (props) => {
    let { data, start } = props;
    let [count, setCount] = useState(1);
    start = start === 0 ? 1 : start / 10 + 1;
    let totalPages = Math.ceil(data.length / 10);
    let arr = pages(count, start, props, totalPages)
    if(totalPages===1) return null
    return (<nav aria-label="Page navigation example">
        <ul class="pagination">
            {

                totalPages > 3 && <li class="page-item">
                    <a class="page-link" href="#" aria-label="Previous" onClick={count === 1 ? () => { return false } : () => setCount(count - 1)}>
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                    </a>
                </li>
            }
            {arr.map(item => {
                return item
            })}
            {totalPages > 3 && <li class="page-item">
                <a class="page-link" href="#" aria-label="Next" onClick={count >= totalPages - 2 ? () => { return false } : () => setCount(count + 1)}>
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                </a>
            </li>}
        </ul>
    </nav>);
}

export default Pagination;

function pages(count, start, props, totalPages) {
    let arr = [];
    for (let i = count; i <= count + 2; i++) {
        let classes = "page-item";
        classes = start === i ? classes + ' active' : classes;
        if (i <= totalPages)
            arr.push(<li class={classes}><a class="page-link" onClick={() => props.onPageSelect(i)}>{i}</a></li>);
    }
    return arr;
}



// WEBPACK FOOTER //
// ./src/components/pagination/pagination.js